import create from "zustand";

const useStore = create((set, get) => {
    return {
        gasStation: null,
        hints: null,
        extensions: null,
        openTimes: null,
        gasStationSlug: null,
        gasStationError: false,
        prices: null,
        loading: ["prices"],
        loadingPrices: false,
        initStore: (slug, gasStation) =>
            set({
                gasStation,
                hints: null,
                extensions: null,
                openTimes: null,
                gasStationSlug: slug,
                gasStationError: false,
                prices: null,
            }),
        startLoading: (section) =>
            set((state) => {
                if (state.loading.includes(section)) {
                    return state;
                }
                return { loading: [...state.loading, section] };
            }),
        stopLoading: (section) =>
            set((state) => ({
                loading: state.loading.filter((item) => item !== section),
            })),
        isLoading: (section) => get().loading.includes(section),
        setLoading: (loading) => set({ loading }),
        setLoadingPrices: (loadingPrices) => set({ loadingPrices }),
        setGasStationError: (value) => set({ gasStationError: value }),
        setGasStation: (gasStation, gasStationSlug) =>
            set({
                gasStation,
                gasStationSlug,
                hints: gasStation.hinweise ?? null,
                openTimes: gasStation.openTimes ?? null,
                extensions: gasStation.erweiterungen ?? null,
            }),
        setPrices: (prices) => set({ prices }),
        setHints: (hints) => set({ hints }),
        setExtensions: (extensions) => set({ extensions }),
        setOpenTimes: (openTimes) => set({ openTimes }),
    };
});

export default useStore;
